

















import Vue from 'vue';
import RuleTrends from '../overview/RuleTrends.vue';
import RuleKeyIndicator from '../overview/RuleKeyIndicator.vue';
import RuleApiOverview from '../overview/RuleApiOverview.vue';
import RuleLogs from '../overview/RuleLogs.vue';

export default Vue.extend({
  components: {
    RuleKeyIndicator,
    RuleTrends,
    RuleApiOverview,
    RuleLogs,
  },
  props: {
    rule: {
      type: Object,
      default: null,
    },
  },
});
